/**
 * Converts a number of bytes to a human-readable string representation.
 * @param bytes - The number of bytes to convert.
 * @returns A string representation of the number of bytes in a human-readable format.
 */
export const bytesToSize = (bytes: number): string => {
  const sizes = ['B', 'KB', 'MB', 'GB', 'TB'];
  if (bytes === 0) return `0 ${sizes[0]}`;
  const i = Math.floor(Math.log(bytes) / Math.log(1024));
  return `${Math.round(bytes / Math.pow(1024, i))} ${sizes[i]}`;
};
